import { CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-dnd-column-with-arrows',
  templateUrl: './dnd-column-with-arrows.component.html',
  styleUrls: ['./dnd-column-with-arrows.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DndColumnWithArrowsComponent implements OnInit {
  @ViewChild('listRef') ref: CdkDropList<string[]>;
  @Input() elements: { label: string; value: any }[];
  @Output() orderChanged = new EventEmitter<{ label: string; value: any }[]>();

  constructor() {}

  ngOnInit() {}

  drop(event: CdkDragDrop<{ label: string; value: any }[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.orderChanged.emit(this.elements);
  }

  moveUp(index: number) {
    if (index === 0) return;
    moveItemInArray(this.ref.data, index, index - 1);
    this.orderChanged.emit(this.elements);
  }

  moveDown(index: number) {
    if (index === this.elements.length - 1) return;
    moveItemInArray(this.ref.data, index, index + 1);
    this.orderChanged.emit(this.elements);
  }
}
